module.exports = __webpack_public_path__ + "static/images/dynamic-rate.9e831cdb45f9e6481e40fdfdcbe7d1b9.svg";